export class UpdateSourceAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateAwsSourceAccountAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
